module.exports = __webpack_public_path__ + "img/aquarell_teaser.d21dfc66.jpg";